import React, { useState } from 'react';
import { SendIcon } from 'lucide-react';
export const QuoteForm = ({
  className = ''
}) => {
  const [formData, setFormData] = useState({
    boatType: '',
    name: '',
    phone: '',
    email: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real implementation, this would send the form data to a server
    console.log('Form submitted:', formData);
    alert('Bedankt voor je aanvraag! We nemen binnen 1 werkdag contact met je op.');
    setFormData({
      boatType: '',
      name: '',
      phone: '',
      email: ''
    });
  };
  return <div className={`${className}`} data-id="element-131">
      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-132">
        <div data-id="element-133">
          <select id="boatType" name="boatType" value={formData.boatType} onChange={handleChange} required className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#234837] text-base" data-id="element-134">
            <option value="" data-id="element-135">Wat voor type boot heb je?</option>
            <option value="sloep" data-id="element-136">Sloep</option>
            <option value="zeilboot" data-id="element-137">Zeilboot</option>
            <option value="motorboot" data-id="element-138">Motorboot</option>
            <option value="jacht" data-id="element-139">Jacht</option>
            <option value="anders" data-id="element-140">Anders</option>
          </select>
        </div>
        <div data-id="element-141">
          <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#234837] text-base" placeholder="Jouw naam" data-id="element-142" />
        </div>
        <div data-id="element-143">
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#234837] text-base" placeholder="Telefoonnummer" data-id="element-144" />
        </div>
        <div data-id="element-145">
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#234837] text-base" placeholder="E-mailadres" data-id="element-146" />
        </div>
        <button type="submit" className="w-full bg-[#234837] hover:bg-[#1a3629] text-white font-bold py-4 px-4 rounded-md transition-colors duration-300 flex items-center justify-center text-lg" data-id="element-147">
          <span data-id="element-148">OFFERTE AANVRAGEN</span>
          <SendIcon size={18} className="ml-2" data-id="element-149" />
        </button>
        <p className="text-center text-sm text-gray-600" data-id="element-150">
          Binnen 24 uur persoonlijk contact - Geen verplichtingen
        </p>
      </form>
    </div>;
};